import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { selected: String }

  static targets = ["field", "select"]

  connect() {
    this.update()
  }

  update() {
    this.selectedValue = this.selectTarget.value
  }

  selectedValueChanged() {
    this.fieldTargets.forEach((field) => {
      const showFor = JSON.parse(field.dataset.showFor)

      field.classList.toggle("hidden", !showFor.includes(this.selectedValue))
    })
  }
}
